import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { flowRight, get } from 'lodash';

import { HeaderStore, userSelector } from '@zocdoc/components/src/Layout';
import insurancePickerSelector from '@zocdoc/components/src/InsurancePicker/data/insurancePickerSelector';
import { clearCarrierAndPlan, openDropdown } from '@zocdoc/components/src/InsurancePicker/data/dropdown-state/dropdownStateActions';

import { withProvider } from '../gql/withProvider';
import { setLocation } from '../../../Shared/LocationCardCarousel/actions';
import { toggleLocationExpanded } from '../../../Shared/Locations/actions';
import { deletePreviewProvider } from '../actions/deletePreviewProvider';
import { getProfilePageParameters } from '../state/selectors';
import { getLocationsCarouselState } from '../../../Shared/LocationCardCarousel/selectors';
import { getSeoRelatedLinks } from '../../../Shared/Seo';
import { getThemeParameters } from '../../../config/theme/selector';
import { getSearchMetadata } from '../../../Search/state';
import isZocdocBrand from '../../../utils/isZocdocBrand';
import { showFindSimilarDoctors } from '../../../config/ab/selector';
import { trackConversion as trackSignInLinkClickConversion } from '../../../config/ab/actions';
import { getPageloadTraceId } from '../../../config/pageload/selector';

import ProfilePage from './view';

import { Actions as GalleryActions } from './PictureGallery';
import {
    hideMap,
    showMap,
    turnBookingSpotlightOn,
    turnBookingSpotlightOff,
    updateUser,
} from '../actions';

const { showGallery } = GalleryActions;

export function mapStateToProps(state) {
    const carouselState = getLocationsCarouselState(state);
    const insurancePickerState = insurancePickerSelector(state);
    const parameters = getProfilePageParameters(state);
    const seoRelatedLinks = getSeoRelatedLinks(state);
    const { directoryId } = getThemeParameters(state);
    const metadata = getSearchMetadata(state);

    return {
        ...parameters,
        canDeletePreviewProfiles: get(parameters, 'user.can_delete_preview_profiles'),
        carrierId: insurancePickerState.carrier,
        deletePreviewProviderFailed: parameters.deletePreviewProviderFailed,
        deletePreviewProviderSucceeded: parameters.deletePreviewProviderSucceeded,
        deletingPreviewProvider: parameters.deletingPreviewProvider,
        directoryId,
        insurancePickerHasBeenOpened: insurancePickerState.dropdownState.hasBeenOpened,
        is1Z: isZocdocBrand(directoryId),
        pageId: get(getPageloadTraceId(state), 'pageTraceId'),
        planId: insurancePickerState.plan,
        procedureId: parameters.reason_visit,
        searchQueryGuid: metadata.searchQueryGuid,
        selectedLocationId: carouselState ? carouselState.locationId : undefined,
        seoRelatedLinks,
        sessionId: metadata.sessionId,
        showFindSimilarDoctors: showFindSimilarDoctors(state),
        trackingId: metadata.trackingId,
    };
}

const wrapActionWithDispatch = (fn, dispatch) => {
    return (...args) => dispatch(fn(...args));
};

const mapDispatchToProps = dispatch => {
    return {
        hideMap: wrapActionWithDispatch(hideMap, dispatch),
        clearCarrierAndPlan: wrapActionWithDispatch(clearCarrierAndPlan, dispatch),
        openInsurancePicker: wrapActionWithDispatch(openDropdown, dispatch),
        setLocation: wrapActionWithDispatch(setLocation, dispatch),
        showGallery: wrapActionWithDispatch(showGallery, dispatch),
        showMap: wrapActionWithDispatch(showMap, dispatch),
        turnBookingSpotlightOn: wrapActionWithDispatch(turnBookingSpotlightOn, dispatch),
        turnBookingSpotlightOff: wrapActionWithDispatch(turnBookingSpotlightOff, dispatch),
        toggleLocationExpanded: wrapActionWithDispatch(toggleLocationExpanded, dispatch),
        deletePreviewProvider: wrapActionWithDispatch(deletePreviewProvider, dispatch),
        setupHeaderStoreSubscription: () => {
            HeaderStore.subscribe(() => {
                const headerState = HeaderStore.getState();
                const user = userSelector(headerState);
                dispatch(updateUser(user));
            });
        },
        trackSignInLinkClickConversion: wrapActionWithDispatch(trackSignInLinkClickConversion, dispatch),
    };
};

export default flowRight(
    hot(module),
    connect(mapStateToProps, mapDispatchToProps),
    withProvider,
)(ProfilePage);
